import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import * as Sentry from "@sentry/angular-ivy";
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppComponent } from './app.component';
import { ButtonsIrisModule, HeaderModule, InputIrisModule, NavbarModule } from 'iris-front';
import { TranslocoRootModule } from './core/transloco-root.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { httpInterceptorProviders } from './core/interceptors';
import { LayoutModule } from './layout/layout.module';
import { ErrorsModule } from './modules/errors/errors.module';
import { DataSharingService } from './core/services';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedModule } from './modules/shared/shared.module';
import { HomeModule } from './modules/home/home.module';
import { NewsletterModule } from './modules/newsletter/newsletter.module';
import { GalleryModule } from './modules/gallery/gallery.module';
import { SeoModule } from './modules/seo/seo.module';
import { ModuleManagerModule } from './modules/module-management/module-manager.module';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { LinksListModule } from './modules/links-list/links-list.module';
import { MainMenuModule } from './modules/main-menu/main-menu.module';
import { VersionerModuleModule } from './modules/versioner-module/versioner-module.module';
import { FirstNoteScrollModule } from './modules/first-note-scroll/first-note-scroll.module';
import { OpeningModule } from './modules/opening/opening.module';
import { BreakingLiveModule } from './modules/breaking-live/breaking-live.module';
import { BlockVideoModule } from './modules/block-video/block-video.module';
import { SponsoredContentModule } from './modules/sponsored-content/sponsored-content.module';
import { InstagramModule } from './modules/instagram/instagram.module';
import { AuthorModule } from './modules/author/author.module';
import { RichmediaAdsModule } from './modules/richmedia-ads/richmedia-ads.module';
import { IaHomeComponent } from './modules/ia/pages/ia-home/ia-home.component';
import { IaComponent } from './modules/ia/ia.component';
import { MultiformatoComponent } from './modules/ia/pages/multiformato/multiformato.component';
import { VozIaComponent } from './modules/ia/pages/voz-ia/voz-ia.component';
import { BlockedFilterComponent } from './modules/ia/pages/filtro/blockedfilter.component';



@NgModule({
  providers: [
    httpInterceptorProviders, 
    DataSharingService,
    AppComponent,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: true,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    }
  ],
  declarations: [
    AppComponent,
    IaHomeComponent,
    IaComponent,
    MultiformatoComponent,
    BlockedFilterComponent,
    VozIaComponent,
  ],
  imports: [
    BrowserModule,
    FontAwesomeModule,
    ButtonsIrisModule,
    InputIrisModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslocoRootModule,
    AppRoutingModule,
    LayoutModule,
    ErrorsModule,
    HeaderModule,
    NavbarModule,
    HomeModule,
    DragDropModule,
    NewsletterModule,
    GalleryModule,
    SharedModule,
    SeoModule,
    ModuleManagerModule,
    BreakingLiveModule,
    VersionerModuleModule,
    NgxDropzoneModule,
    FormsModule,
    LinksListModule,
    MainMenuModule,
    FirstNoteScrollModule,
    OpeningModule,
    BlockVideoModule,
    AuthorModule,
    InstagramModule,
    SponsoredContentModule,
    RichmediaAdsModule
  ],
  
  bootstrap: [AppComponent],
})
export class AppModule { }
